import * as Yup from 'yup';
import { PasswordReset } from '../../../common/models';

export function useValidationSchema() {
  return Yup.object<PasswordReset>().shape({
    email: Yup.string().nullable().required(),
  });
}
